// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Re","articleImagesWrap":"Se","articleImage":"Te","singleImage":"Ue"};